import React from "react";
import { graphql } from "gatsby";
import { BoardMembersGrid } from "./BoardMembersGrid";
import {
  KontentComponentSettings,
  KontentLinkedDataStaffMember,
  KontentLinkedMediaImage,
  KontentLinks,
  KontentRichText,
  StringValue,
} from "../../../types";
import { formatLinks } from "../../../lib/links";
import { formatImages } from "../../../lib/images";
import { getMultiChoice } from "../../../lib/multichoice";

interface Props extends KontentComponentSettings {
  subhead: StringValue;
  staff_members: KontentLinkedDataStaffMember;
  simple_rte__text: KontentRichText;
  link_configuration__link: KontentLinks;
}

const BoardMembersGridContainer: React.FC<Props> = ({
  staff_members,
  subhead,
  simple_rte__text,
  link_configuration__link,
  component_settings__anchor_name,
  component_settings__hide_on_mobile,
  id,
}) => {
  const formatStaffMembers = () => {
    return staff_members.value.map((member) => {
      const memberElements = member?.elements;
      const image = formatImages(memberElements?.image?.value[0]?.elements);

      return {
        firstName: memberElements?.first_name?.value,
        lastName: memberElements?.last_name?.value,
        appointedYear: memberElements?.appointed_year?.value,
        image: image.largeImage,
      };
    });
  };
  const cta = formatLinks(link_configuration__link?.modular_content)[0];
  const staffMembers = formatStaffMembers();

  return (
    <BoardMembersGrid
      id={id}
      subhead={subhead.value}
      text={simple_rte__text}
      ctaAriaLabel={cta?.ariaLabel}
      ctaHref={cta?.href}
      ctaTarget={cta?.target}
      ctaLabel={cta?.label}
      staffMembers={staffMembers}
      anchor={component_settings__anchor_name.value}
      hideOnMobile={
        getMultiChoice(component_settings__hide_on_mobile) === "yes"
      }
    ></BoardMembersGrid>
  );
};

export default BoardMembersGridContainer;

export const fragmentBoardMembersGrid = graphql`
  fragment BoardMembersGrid on kontent_item_component___board_members_grid {
    elements {
      subhead {
        value
      }
      staff_members {
        ...kontentStaffMember
      }
      simple_rte__text {
        ...kontentSimpleRichText
      }
      link_configuration__link {
        modular_content {
          ...kontentRichTextLink
        }
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
    }
  }
`;
